module.exports = function() {
  return new Worker(__webpack_public_path__ + "18330159dfb9127a083d.worker.js");
};